'use strict';

module.exports = require('./lib/get-appropriate-image-url');
